import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { Table, Button, message, Select } from 'antd';
import { getDirectusClient } from '../../lib/directus';
import { createUser, readRoles } from '@directus/sdk';

const Cargaruser = () => {
  const [excelData, setExcelData] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);
  const [failedUsers, setFailedUsers] = useState([]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const directus = await getDirectusClient();
        const rolesData = await directus.request(readRoles());
        setRoles(rolesData);
      } catch (err) {
        message.error('Error al cargar roles: ' + err.message);
      }
    };
    fetchRoles();
  }, []);

  const handleFileUpload = (e) => {
    try {
      const file = e.target.files[0];
      if (!file) {
        setError('Por favor seleccione un archivo');
        return;
      }

      const reader = new FileReader();

      reader.onload = (event) => {
        try {
          const workbook = XLSX.read(event.target.result, { type: 'binary' });
          const sheetNames = workbook.SheetNames;
          
          if (!sheetNames.includes('tienda')) {
            setError('El archivo debe contener la hoja "tienda"');
            return;
          }

          const worksheet = workbook.Sheets['tienda'];
          const data = XLSX.utils.sheet_to_json(worksheet);

          if (!data.length) {
            setError('La hoja "tienda" no puede estar vacía');
            return;
          }

          setExcelData(data);
          setError('');
        } catch (err) {
          setError('Error al procesar el archivo: ' + err.message);
        }
      };

      reader.onerror = () => {
        setError('Error al leer el archivo');
      };

      reader.readAsBinaryString(file);
    } catch (err) {
      setError('Error al cargar el archivo: ' + err.message);
    }
  };

  const handleUploadToDirectus = async () => {
    if (!selectedRole) {
      message.error('Por favor seleccione un rol');
      return;
    }

    setLoading(true);
    setFailedUsers([]);
    const failedList = [];

    try {
      const directus = await getDirectusClient();
      
      for (const user of excelData) {
        try {
          await directus.request(
            createUser({
              id: user.id,
              first_name: user.first_name,
              email: user.email,
              password: user.password || 'defaultPassword123',
              celular: user.celular,
              idremoto: user.id,
              role: selectedRole,
              correo: user.correo,
              telefono: user.telefono,
              documento: user.documento,
              bodega: 9,
              superior: user.superior
            })
          );
        } catch (err) {
          failedList.push({
            ...user,
            error: err.message
          });
        }
      }
      
      setFailedUsers(failedList);
      
      if (failedList.length === 0) {
        message.success('Todas las tiendas fueron cargadas exitosamente');
      } else {
        message.warning(`${failedList.length} tiendas no pudieron ser cargadas. Ver detalles en la tabla de errores.`);
      }
      
      setExcelData([]);
    } catch (err) {
      message.error('Error general al cargar tiendas: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'first_name',
      key: 'first_name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono',
      key: 'telefono',
    },
    {
      title: 'ID Remoto',
      dataIndex: 'idremoto',
      key: 'idremoto',
    },
    {
      title: 'Correo',
      dataIndex: 'correo',
      key: 'correo',
    },
    {
      title: 'Superior',
      dataIndex: 'superior',
      key: 'superior',
    }
  ];

  const errorColumns = [
    ...columns,
    {
      title: 'Error',
      dataIndex: 'error',
      key: 'error',
    }
  ];

  return (
    <div className="container mt-4">
      <h2>Cargar Excel de Tiendas</h2>
      <div style={{ marginBottom: '20px' }}>
        <Select
          style={{ width: 200, marginRight: 16 }}
          placeholder="Seleccione un rol"
          onChange={setSelectedRole}
          value={selectedRole}
        >
          {roles.map(role => (
            <Select.Option key={role.id} value={role.id}>
              {role.name}
            </Select.Option>
          ))}
        </Select>
        <Button 
          type="primary" 
          onClick={handleUploadToDirectus}
          loading={loading}
          disabled={excelData.length === 0 || !selectedRole}
        >
          Procesar Datos
        </Button>
      </div>
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        className="form-control mb-3"
      />

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {excelData.length > 0 && !error && (
        <div>
          <Table 
            dataSource={excelData} 
            columns={columns} 
            rowKey={(record) => record.id || Math.random()}
          />
        </div>
      )}

      {failedUsers.length > 0 && (
        <div style={{ marginTop: '20px' }}>
          <h3>Tiendas con errores</h3>
          <Table 
            dataSource={failedUsers} 
            columns={errorColumns} 
            rowKey={(record) => record.id || Math.random()}
          />
        </div>
      )}
    </div>
  );
};

export default Cargaruser;
